import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export abstract class BaseForm<
  T,
  Form extends { [K in keyof Form]: AbstractControl<unknown, unknown> } = never,
> {
  protected formGroup: FormGroup<Form>;
  public get asFormGroup(): FormGroup<Form> {
    return this.formGroup;
  }

  public get values(): T {
    return this.formGroup.getRawValue() as T;
  }

  get validators(): (ValidatorFn | null | undefined)[] {
    return Object.keys(this.formGroup.controls).map(key => this.formGroup.get(key)?.validator);
  }

  public setFormValues(data: Partial<T>): void {
    this.formGroup.patchValue(data as never);
  }

  public setValue<Key extends keyof T, Value extends T[Key]>(field: Key, value: Value | null): void {
    this.formGroup.get(field as string)?.setValue(value as never);
  }
}
